import { mergeListOfStory, modifyHomeStoryListOnDelete, modifyHomeStoryListOnRead, modifyProfileStoryListOnDelete, modifyProfileStoryListOnRead } from "../../components/helper/Utils";
import {
  FETCH_HOME_STORIES_START,
  FETCH_HOME_STORIES_SUCCESS,
  FETCH_HOME_STORIES_FAILURE,
  FETCH_PROFILE_STORIES_START,
  FETCH_PROFILE_STORIES_SUCCESS,
  FETCH_PROFILE_STORIES_FAILURE,
  FETCH_STORY_START,
  FETCH_STORY_SUCCESS,
  FETCH_STORY_FAILURE,
  SAVE_STORY_START,
  SAVE_STORY_SUCCESS,
  SAVE_STORY_FAILURE,
  SAVE_FROM_POST_START,
  SAVE_FROM_POST_SUCCESS,
  SAVE_FROM_POST_FAILURE,
  UPDATE_STORY_DATA_STATUS_START,
  UPDATE_STORY_DATA_STATUS_SUCCESS,
  UPDATE_STORY_DATA_STATUS_FAILED,
  CLEAR_PROFILE_STORIES_START,
  DELETE_STORY_START,
  DELETE_STORY_SUCCESS,
  DELETE_STORY_FAILURE,
} from "../actions/ActionConstant";

const initialState = {
  saveStory: {
    data: {},
    loading: false,
    error: false,
    inputData: {},
    loadingButtonContent: null,
    buttonDisable: false,
  },
  saveFromPost: {
    data: {},
    loading: false,
    error: false,
    inputData: {},
  },
  homeStories: {
    data: [],
    loading: false,
    error: null,
    metadata: {}
  },
  getStory: {
    data: {},
    loading: false,
    error: false,
    inputData: {},
  },
  profileStories: {
    data: [],
    loading: false,
    error: null,
    metadata: {}
  },
  updateStoryStatus: {
    data: {},
    loading: false,
    error: false,
    inputData: {},
  },
  delStory: {
    data: {},
    loading: false,
    error: false,
    inputData: {},
  },
};

const StoriesReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_HOME_STORIES_START:
      return {
        ...state,
        homeStories: {
          ...state.homeStories,
          loading: true,
          error: null
        },
      };
    case FETCH_HOME_STORIES_SUCCESS:
      const currentHomeStory = state.homeStories?.data || [];
      const fetchedHomeStory = Array.isArray(action?.data?.data) ? action.data.data : [];
      return {
        ...state,
        homeStories: {
          loading: false,
          data: mergeListOfStory(currentHomeStory, fetchedHomeStory, "user_id"),
          error: null,
          metadata: action.data?.metadata
        },
      };
    case FETCH_HOME_STORIES_FAILURE:
      return {
        ...state,
        homeStories: {
          loading: false,
          data: null,
          error: action.error
        },
      };
    case SAVE_FROM_POST_START:
      return {
        ...state,
        saveFromPost: {
          data: {},
          error: false,
          loading: true,
          inputData: action.data,
        },
      }
    case SAVE_FROM_POST_SUCCESS:
      return {
        ...state,
        saveFromPost: {
          data: action.data,
          error: false,
          loading: false,
          inputData: {},
        },
      }
    case SAVE_FROM_POST_FAILURE:
      return {
        ...state,
        saveFromPost: {
          data: {},
          loading: false,
          inputData: {},
          error: action.error,
        },
      };
    case FETCH_PROFILE_STORIES_START:
      return {
        ...state,
        profileStories: {
          ...state.profileStories,
          loading: true,
          error: null
        },
      };
    case FETCH_PROFILE_STORIES_SUCCESS:
      const currentStory = state.profileStories?.data || [];
      const fetchedStory = Array.isArray(action?.data?.data) ? action.data.data : [];
      return {
        ...state,
        profileStories: {
          loading: false,
          data: mergeListOfStory(currentStory, fetchedStory),
          error: null,
          metadata: action.data?.metadata
        },
      };
    case FETCH_PROFILE_STORIES_FAILURE:
      return {
        ...state,
        profileStories: {
          loading: false,
          data: null,
          error: action.error
        },
      };
    case FETCH_STORY_START:
      return {
        ...state,
        getStory: {
          ...state.getStory,
          loading: true,
          error: null
        },
      };
    case FETCH_STORY_SUCCESS:
      return {
        ...state,
        getStory: {
          loading: false,
          data: action.data,
          error: null,
        },
      };
    case FETCH_STORY_FAILURE:
      return {
        ...state,
        getStory: {
          loading: false,
          data: null,
          error: true
        },
      };
    case SAVE_STORY_START:
      return {
        ...state,
        saveStory: {
          data: {},
          error: false,
          loading: true,
          buttonDisable: true,
          inputData: action.data,
          loadingButtonContent: "Uploading... Please wait",
        },
      };
    case SAVE_STORY_SUCCESS:
      return {
        ...state,
        saveStory: {
          error: false,
          inputData: {},
          loading: false,
          data: action.data,
          buttonDisable: false,
          loadingButtonContent: null,
        },
      };
    case SAVE_STORY_FAILURE:
      return {
        ...state,
        saveStory: {
          data: {},
          loading: false,
          inputData: {},
          error: action.error,
          buttonDisable: false,
          loadingButtonContent: null,
        },
      };

    case UPDATE_STORY_DATA_STATUS_START:
      return {
        ...state,
        updateStoryStatus: {
          data: {},
          error: false,
          loading: true,
          inputData: action.data,
        },
      }

    case UPDATE_STORY_DATA_STATUS_SUCCESS:
      let obj = {}
      if (state.profileStories.metadata?.numberOfPages) {
        obj = {
          profileStories: {
            ...state.profileStories,
            data: modifyProfileStoryListOnRead(state.profileStories.data, action.data)
          }
        }
      }
      if (state.homeStories.metadata?.numberOfPages) {
        obj = {
          homeStories: {
            ...state.homeStories,
            data: modifyHomeStoryListOnRead(state.homeStories.data, action.data)
          }
        }
      }
      return {
        ...state,
        updateStoryStatus: {
          data: action.data,
          error: false,
          loading: false,
          inputData: {},
        },
        ...obj
      }

    case UPDATE_STORY_DATA_STATUS_FAILED:
      return {
        ...state,
        updateStoryStatus: {
          data: {},
          loading: false,
          inputData: {},
          error: action.error,
        },
      };

    case CLEAR_PROFILE_STORIES_START:
      return {
        ...state,
        profileStories: {
          loading: false,
          data: [],
          error: null,
          metadata: {}
        },
        homeStories: {
          data: [],
          loading: false,
          error: null,
          metadata: {}
        },
      };

    case DELETE_STORY_START:
      return {
        ...state,
        delStory: {
          inputData: action.data,
          data: {},
          loading: true,
          error: false,
          loadingButtonContent: "Loading... Please wait",
          buttonDisable: true,
        },
      };

    case DELETE_STORY_SUCCESS:
      let tmpObj = {}
      if (action.data?.storyFrom === 'profile') {
        tmpObj = {
          profileStories: {
            ...state.profileStories,
            data: modifyProfileStoryListOnDelete(state.profileStories.data, action.data)
          }
        }
      } else {
        tmpObj = {
          homeStories: {
            ...state.homeStories,
            data: modifyHomeStoryListOnDelete(state.homeStories.data, action.data)
          }
        }
      }
      return {
        ...state,
        delStory: {
          data: action.data,
          loading: false,
          error: false,
          inputData: {},
          loadingButtonContent: null,
          buttonDisable: false,
        },
        ...tmpObj
      };

    case DELETE_STORY_FAILURE:
      return {
        ...state,
        delStory: {
          data: {},
          loading: true,
          error: action.error,
          inputData: {},
          loadingButtonContent: null,
          buttonDisable: false,
        },
      };

    default:
      return {
        ...state,
      };
  }
};

export default StoriesReducer;
